export default __webpack_public_path__ + "static/media/photo--sm--29.9f06b2e3.jpg";